import LabelsList from './labelslist'

export default LabelsList
